import { Sparkles } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { CardButton } from '@/components/card-button'
import { PageHeader } from '@/components/commons'
import {
	ADMIN_MENU_GROUPS,
	ADMIN_MENU_SHORTCUTS,
	adminGroupRoute,
} from '@/constants/admin-menu'
import { hasRouteAccess } from '@/constants/permissions'
import { RELEASE_NOTES } from '@/constants/release-notes'
import { ROUTES } from '@/constants/routes'
import { useAuthStore } from '@/store'

export const AdministrationPage = () => {
	const navigate = useNavigate()
	const { t } = useTranslation()
	const user = useAuthStore((s) => s.user)

	const canAccess = (route: string) =>
		!user || hasRouteAccess(user.role, route, user.badge)

	// Grupo sem nenhum item acessível some; com um único item, o card leva direto a ele
	const groups = ADMIN_MENU_GROUPS.map((group) => ({
		...group,
		items: group.items.filter((item) => canAccess(item.route)),
	})).filter((group) => group.items.length > 0)
	const shortcuts = ADMIN_MENU_SHORTCUTS.filter((item) => canAccess(item.route))
	const latestRelease = RELEASE_NOTES[0]

	return (
		<div className="px-4 py-6 sm:px-6">
			<PageHeader
				title={t('administration.title')}
				description={t('administration.subtitle')}
				onBack={() => navigate(ROUTES.DASHBOARD.HOME)}
			/>

			<div className="grid grid-cols-1 items-stretch gap-3 sm:grid-cols-2 lg:grid-cols-3">
				<CardButton
					icon={<Sparkles className="size-5 text-kaefer-forest-green" />}
					iconBg="bg-kaefer-forest-green/10"
					borderColor="border-l-kaefer-forest-green"
					title={t('administration.whatsNew.title')}
					description={t('administration.whatsNew.cardDescription', {
						version: latestRelease.version,
					})}
					onClick={() => navigate(ROUTES.ADMINISTRATION.WHATS_NEW)}
				/>
				{groups.map((group) => (
					<CardButton
						key={group.id}
						icon={<group.icon className="size-5 text-kaefer-medium-grey" />}
						iconBg="bg-kaefer-medium-grey/10"
						borderColor="border-l-kaefer-medium-grey"
						title={t(`administration.groups.${group.id}.title`)}
						description={t(`administration.groups.${group.id}.description`)}
						onClick={() =>
							navigate(
								group.items.length === 1
									? group.items[0].route
									: adminGroupRoute(group.id),
							)
						}
					/>
				))}
				{shortcuts.map((item) => (
					<CardButton
						key={item.id}
						icon={<item.icon className="size-5 text-kaefer-medium-grey" />}
						iconBg="bg-kaefer-medium-grey/10"
						borderColor="border-l-kaefer-medium-grey"
						title={t(`administration.options.${item.id}.title`)}
						description={t(`administration.options.${item.id}.description`)}
						onClick={() => navigate(item.route)}
					/>
				))}
			</div>
		</div>
	)
}
